export const DETAIL_MAP_SET_PARAMS = "DETAIL_MAP_SET_PARAMS";
export const DETAIL_MAP_SET_PARAMS_DONE = "DETAIL_MAP_SET_PARAMS_DONE";
